import React from "react";
import { FileField, FileInput } from "react-admin";

const InvoiceInput = (props) => (
	<FileInput {...props} accept="application/pdf" multiple={false}>
		<FileField source="path" />
	</FileInput>
);
export default InvoiceInput;
